import React from "react";
import { Outlet } from "react-router-dom";

const Index = () => {
  return (
    <div className="mx-4">
      <Outlet />
    </div>
  );
};

export default Index;
